// extracted by mini-css-extract-plugin
export var articleInfoContainer = "bg_dl";
export var articleInfoItem = "bg_dm";
export var itemChild = "bg_dn";